module.exports = __webpack_public_path__ + "img/bus_marker_green.de1810be.png";